import { globalApi as api } from '../../api';

// export const uploadAct = async (fileData) => {
//     try {
//         const formData = new FormData();
//         formData.append('file', fileData);
//         const token = sessionStorage.getItem('token');
//         const response = await api.post('/upload_act', formData, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'multipart/form-data'
//             }
//         });
//         return response.data
//     } catch (error) {
//         throw error.response ? error.response.data.error : error.message;
//     }
// }




export const uploadAct = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_act', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};

export const fetchAct = async () => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_acts`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const updateAct = async (id, salaryData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_act/${id}`, salaryData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteAct = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_act/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteAct = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/multiple_delete_act', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

// export const uploadRule = async (fileData) => {
//     try {
//         const formData = new FormData();
//         formData.append('file', fileData);
//         const token = sessionStorage.getItem('token');
//         const response = await api.post('/upload_rules', formData, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'multipart/form-data'
//             }
//         });
//         return response.data
//     } catch (error) {
//         throw error.response ? error.response.data.error : error.message;
//     }
// }




export const uploadRule = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_rules', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};



export const fetchRule = async () => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_rules`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const updateRule = async (id, salaryData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_rule/${id}`, salaryData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteRule = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_rule/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteRule = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/multiple_delete_rules', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

// export const uploadActivity = async (fileData) => {
//     try {
//         const formData = new FormData();
//         formData.append('file', fileData);
//         const token = sessionStorage.getItem('token');
//         const response = await api.post('/upload_activity', formData, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'multipart/form-data'
//             }
//         });
//         return response.data
//     } catch (error) {
//         throw error.response ? error.response.data.error : error.message;
//     }
// }


export const uploadActivity = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_activity', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};



export const fetchActivity = async () => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_activities`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const updateActivity = async (id, salaryData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_activity/${id}`, salaryData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteActivity = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_activity/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteActivity = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/multiple_delete_activities', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const fetchTemplate = async () => {
    try {
        const response = await api.get(`/get_templates`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const createTemplate = async (data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/add_single_templates', data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
// export const uploadTemplate = async (fileData) => {
//     try {
//         const formData = new FormData();
//         formData.append('file', fileData);
//         const token = sessionStorage.getItem('token');
//         const response = await api.post('/upload_templates', formData, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'multipart/form-data'
//             }
//         });
//         return response.data
//     } catch (error) {
//         throw error.response ? error.response.data.error : error.message;
//     }
// }



export const uploadTemplate = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_templates', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};

export const updateTemplate = async (id, salaryData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_template/${id}`, salaryData, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteTemplate = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_template/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteTemplate = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/multiple_delete_templates', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}